export default {
  CubeInvestments: 'Cube Investments sp. z o.o.',
  IT4Biznes: 'IT4Biznes Marcin Hatalak',
  LOSO: 'LOSO sp. z o.o.',
  PGS: 'PGS Software (now part of Xebia)',
  RedDotGames: 'Red Dot Games',
  Sanddev: 'Sanddev sp. z o.o.',
  Sandstream: 'Sandstream Development',
  SelfEmployment: 'Self-employment'
}
